export let STOREFRONT_ADDRESS = "0x495f947276749Ce646f68AC8c248420045cb7b5e";
export let DEATHWISH_ADDRESS = "0x67E3e965CE5Ae4D6a49ac643205897aCB32fCF6e";